<section class="mb-5">
  <h2 class="h4 fw-bold mb-4 text-secondary">
    {{ 'CUSTOMER-ACCOUNT.VISITS-VIEW.PENDING-VISITS-TITLE' | translate}}
  </h2>
  <div class="visits-container row">
    <div class="col-12 col-md-8 col-lg-7 flex-column">
      <div *ngIf="pendingVisits.length === 0"
           class="visits-placeholder mb-3">
        {{ 'CUSTOMER-ACCOUNT.VISITS-VIEW.PENDING-VISITS-PLACEHOLDER' | translate}}
      </div>
      <ng-container *ngIf="pendingVisits.length > 0">
        <app-customer-account-visit *ngFor="let pendingVisit of pendingVisits"
                                    [visit]="pendingVisit"
                                    [@inOutAnimation]
                                    (visitCancelled)="visitCancelled($event)">
        </app-customer-account-visit>
      </ng-container>
    </div>
  </div>
</section>

<section class="mb-5">
  <h2 class="h4 fw-bold mb-4 text-secondary">
    {{ 'CUSTOMER-ACCOUNT.VISITS-VIEW.HISTORY-VISITS-TITLE' | translate}}
  </h2>
  <div class="visits-container row">
    <div class="col-12 col-md-8 col-lg-7 flex-column">
      <div class="visits-placeholder mb-3 "
           *ngIf="visitsHistory.length === 0">
        {{ 'CUSTOMER-ACCOUNT.VISITS-VIEW.COMPLETED-VISITS-PLACEHOLDER' | translate}}
      </div>
      <ng-container *ngIf="visitsHistory.length > 0">
        <app-customer-account-visit *ngFor="let historyVisit of visitsHistory"
                                    [@inOutAnimation]
                                    [visit]="historyVisit">
        </app-customer-account-visit>
      </ng-container>
    </div>
  </div>
</section>
